import { noop, isString } from 'underscore';
import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Stack, TextField } from '@fluentui/react';
import { getDomain } from '@bingads-webui/url-util';

import { validatePath } from './validation';

const urlPathStyle = {
  root: {
    flexFlow: 'row wrap',
    wordBreak: 'break-all',
  },
};

export function UrlPathFluent({
  value,
  url,
  i18n,
  onChange,
}) {
  const [Path1, Path2] = value;
  const urlDomain = useMemo(() => getDomain(url), [url]);
  const onPathChange = useCallback((path, newValue) => {
    const errors = validatePath([path === 'Path1' ? newValue : Path1, path === 'Path2' ? newValue : Path2], i18n);
    onChange(errors, { Path1, Path2, [path]: newValue });
  }, [Path1, Path2, i18n, onChange]);

  const onPath1Change = useCallback((event, newValue) => {
    onPathChange('Path1', newValue);
  }, [onPathChange]);

  const onPath2Change = useCallback((event, newValue) => {
    onPathChange('Path2', newValue);
  }, [onPathChange]);

  return (
    <Stack
      className="url-path"
      tokens={{
        childrenGap: 6,
      }}
    >
      <Stack
        horizontal
        verticalAlign="baseline"
        styles={urlPathStyle}
        tokens={{
          childrenGap: 6,
        }}
      >
        <div className="display-url-text">
          {isString(urlDomain) && urlDomain.length > 0 ?
                urlDomain :
                'www.example.com'
          }
        </div>
        <div className="url-separator">/</div>
        <TextField
          className="path1"
          value={Path1}
          onChange={onPath1Change}
          ariaLabel={i18n.getString(_TL_('Manual text input path1'))}
        />
        <div className="url-separator">/</div>
        <TextField
          className="path2"
          value={Path2}
          onChange={onPath2Change}
          ariaLabel={i18n.getString(_TL_('Manual text input path2'))}
        />
      </Stack>
    </Stack>
  );
}

UrlPathFluent.propTypes = {
  config: PropTypes.shape({
  }).isRequired,
  value: PropTypes.arrayOf(PropTypes.string).isRequired,
  url: PropTypes.string.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  onChange: PropTypes.func,
};

UrlPathFluent.defaultProps = {
  onChange: noop,
};
